import { jsPDF } from "jspdf";
import { obterDataFormatada } from "../../../../utils";
import { createHeaderSenado } from "../../../model/header";
import { createFooterSenado } from "../../../model/footer";

export function relatorioDeCargaPatrimonialDetalhada(ibp, title) {
  let item = ibp;

  // this.$service = new ResourceService(`/api/tarefaspedido/pedido`);

  // let {
  //   data: { content },
  // } = await this.$service.findById(item);

  // let content = item;

  console.log(item);

  const doc = new jsPDF({
    putOnlyUsedFonts: true,
    orientation: "landscape",
  });

  createHeaderSenado(doc, title);
  createFooterSenado(doc);

  //   doc.text(
  //     `RECEBEMOS A(S) MERCADORIA(S) DA NOTA FISCAL Nº ${item.notaFiscal}, ENTREGUE PELA EMPRESA Nº  ${getCNPJComMascara} - DE RAZÃO SOCIAL
  // `,
  //     10,
  //     40,
  //     null,
  //     null,
  //     "left"
  //   );
  //   doc.text(
  //     ` ${item.fornecedor.razaoSocial}, PELO PRAZO MÁXIMO DE _____ DIAS ÚTEIS, ESTANDO A(S) MERCADORIA(S)
  //         `,
  //     10,
  //     45,
  //     null,
  //     null,
  //     "left"
  //   );
  //   doc.text(
  //     `EM CONFORMIDADE COM O(S) NUMERO(S) DE EMPENHO A SEGUIR E EM PERFEITAS CONDIÇÕES, SERÁ DADO O RECEBIMENTO DEFINITIVO`,
  //     10,
  //     50,
  //     null,
  //     null,
  //     "left"
  //   );

  //   doc.text(
  //     ` E A NOTA FISCAL DEVIDADAMENTE ENCAMINHADA PARA O PAGAMENTO.`,
  //     10,
  //     55,
  //     null,
  //     null,
  //     "left"
  //   );

  //   doc.text(
  //     `____________________________________________________`,
  //     100,
  //     105,
  //     null,
  //     null,
  //     "left"
  //   );

  //   doc.text(`${item.responsavel.nome}`, 135, 109, null, null, "left");

  //   const generateDataTarefa = () => {
  //     const result = [];

  //     if (item.itens) {
  //       item.itens.map((c) => {
  //         result.push({
  //           EMPENHO: c.empenho.numero,
  //           DESCRIÇÃO: c.produto.descricaoResumida,
  //           "VALOR UNITÁRIO": c.valorRecebido.toFixed(2).replace(".", ","),
  //           "VALOR SERVIÇO (R$)": c.valorServico.toFixed(2).replace(".", ","),
  //           "QTDE.": c.quantidadeRecebida.toFixed(2).replace(".", ","),
  //           "VALOR TOTAL (R$)": (
  //             (c.valorRecebido + c.valorServico) *
  //             c.quantidadeRecebida
  //           )
  //             .toFixed(2)
  //             .replace(".", ","),
  //         });
  //       });
  //     }

  //     return result;
  //   };

  //   const createHeadersTarefa = (keys) => {
  //     const result = [];
  //     for (let i = 0; i < keys.length; i += 1) {
  //       result.push({
  //         id: keys[i],
  //         name: keys[i],
  //         prompt: keys[i],
  //         width:
  //           // (keys[i] === "Nº" && 30) ||
  //           // (keys[i] === "Nº PEDIDO" && 30) ||
  //           (keys[i] === "DESCRIÇÃO" && 70) ||
  //           (keys[i] === "EMPENHO" && 70) ||
  //           // (keys[i] === "SOLICITANTE" && 50) ||
  //           55,
  //         align: "center",
  //         padding: 0,
  //       });
  //     }
  //     return result;
  //   };

  //   const headersTarefa = createHeadersTarefa([
  //     "EMPENHO",
  //     "DESCRIÇÃO",
  //     "VALOR UNITÁRIO",
  //     "VALOR SERVIÇO (R$)",
  //     "QTDE.",
  //     "VALOR TOTAL (R$)",
  //   ]);

  //   // doc.setFont("", "bold");
  //   // doc.text("HISTÓRICO DE TAREFAS DO PEDIDO.:", 10, 100, null, null, "left");
  //   // doc.setFont("", "normal");

  //   doc.table(10, 65, generateDataTarefa(), headersTarefa, {
  //     fontSize: 10,
  //     autoSize: false,
  //     // cellStart:"               "
  //   });

  /**

      * table 1
      empenho
itens.empenho.descricao

descricao
itens.produto.descricaoResumida

valor unitario
itens.valorRecebido

valor serviço (R$)
itens.valorServiço

QTDE.
itens.quantidadeRecebida

Valor total (R$)
(itens.valorRecebido + itens.valorServiço) * itens.quantidadeRecebida

      table 2 com subtotal
       */

  // doc.text("SOLICITANTE:", 10, 44, null, null, "left");
  // doc.text("DATA PEDIDO:", 10, 48, null, null, "left");
  // doc.text("Nº PEDIDO:", 10, 52, null, null, "left");
  // doc.text("SITUAÇÃO:", 10, 56, null, null, "left");

  // doc.setFontSize(11);
  // doc.setFont("", "normal");

  // doc.text(
  //   `${content[0].pedido.departamentoResponsavel.descricao}`,
  //   42,
  //   40,
  //   null,
  //   null,
  //   "left"
  // );

  // doc.text(
  //   `${content[0].pedido.solicitante.nome}`,
  //   39,
  //   44,
  //   null,
  //   null,
  //   "left"
  // );

  // doc.text(
  //   `${formatarData(content[0].pedido.dhCriacao)} - ${obterHoraFormatada(
  //     content[0].pedido.dhCriacao
  //   )}`,
  //   39,
  //   48,
  //   null,
  //   null,
  //   "left"
  // );

  // doc.text(`${content[0].pedido.id}`, 32, 52, null, null, "left");

  // doc.text(
  //   `${content[0].pedido.status.descricao}`,
  //   33,
  //   56,
  //   null,
  //   null,
  //   "left"
  // );

  // let primeiraTabela = {};
  // let ultimaChave = content.length - 1;

  // if (content[ultimaChave] && content[0].itens[0]) {
  //   primeiraTabela.almoxarifado =
  //     content[
  //       ultimaChave
  //     ].itens[0].itemPedido.almoxarifadoProduto.almoxarifado.descricao;

  //   primeiraTabela.numero =
  //     content[ultimaChave].itens[0].itemPedido.almoxarifadoProduto.numero;

  //   primeiraTabela.descricao =
  //     content[
  //       ultimaChave
  //     ].itens[0].itemPedido.almoxarifadoProduto.descricao;

  //   primeiraTabela.tipoMedida =
  //     content[
  //       ultimaChave
  //     ].itens[0].itemPedido.almoxarifadoProduto.produto.tipoMedida.descricao;

  //   if (
  //     content[ultimaChave].itens[0] !== undefined &&
  //     content[ultimaChave].itens[0].qtdAceita !== undefined
  //   ) {
  //     primeiraTabela.qtdAceita =
  //       content[ultimaChave].itens[0].qtdAceita.toFixed(2);
  //   }

  //   if (
  //     content[ultimaChave].itens[0].itemPedido !== undefined &&
  //     content[ultimaChave].itens[0].qtdSolicitada !== undefined
  //   ) {
  //     primeiraTabela.qtdSolicitada =
  //       content[ultimaChave].itens[0].qtdSolicitada.toFixed(2);
  //   }

  //   if (
  //     content[ultimaChave].itens[0] !== undefined &&
  //     content[ultimaChave].itens[0].retirada !== undefined
  //   ) {
  //     primeiraTabela.retirada =
  //       content[ultimaChave].itens[0].retirada.toFixed(2);
  //   }

  //   if (!primeiraTabela.retirada) {
  //     primeiraTabela.retirada = "-";
  //   }

  //   if (!primeiraTabela.qtdAceita) {
  //     primeiraTabela.qtdAceita = "-";
  //   }

  //   if (!primeiraTabela.qtdSolicitada) {
  //     primeiraTabela.qtdSolicitada = "-";
  //   }
  // }

  // const generateData = () => {
  //   const result = [];

  //   result.push({
  //     "Nº PRODUTO": primeiraTabela.numero,
  //     DESCRIÇÃO: primeiraTabela.descricao,
  //     ALMOXARIFADO: primeiraTabela.almoxarifado,
  //     UNIDADE: primeiraTabela.tipoMedida,
  //     SOLICITADO: primeiraTabela.qtdSolicitada,
  //     APROVADO: primeiraTabela.qtdAceita,
  //     RETIRADA: primeiraTabela.retirada,
  //   });

  //   return result;
  // };

  // const createHeaders = (keys) => {
  //   const result = [];
  //   for (let i = 0; i < keys.length; i += 1) {
  //     result.push({
  //       id: keys[i],
  //       name: keys[i],
  //       prompt: keys[i],
  //       width:
  //         (keys[i] === "Nº PRODUTO" && 50) ||
  //         (keys[i] === "DESCRIÇÃO" && 70) ||
  //         (keys[i] === "ALMOXARIFADO" && 70) ||
  //         (keys[i] === "SOLICITADO" && 50) ||
  //         40,
  //       align: "center",
  //       padding: 0,
  //     });
  //   }
  //   return result;
  // };

  // const headers = createHeaders([
  //   "Nº PRODUTO",
  //   "DESCRIÇÃO",
  //   "ALMOXARIFADO",
  //   "UNIDADE",
  //   "SOLICITADO",
  //   "APROVADO",
  //   "RETIRADA",
  // ]);

  // doc.table(10, 62, generateData(), headers, {
  //   fontSize: 10,
  //   autoSize: false,
  // });

  // const generateDataTarefa = () => {
  //   const result = [];

  //   if (content) {
  //     content.map((c) => {
  //     console.log(c);
  //       result.push({
  //         Nº: c.id.toString(),
  //         "Nº PEDIDO": c.pedido.id.toString(),
  //         STATUS: c.status.descricao,
  //         SOLICITANTE: c.pedido.solicitante.nome,
  //         DESTINO:
  //           c.itens[0] &&
  //           c.itens[0].itemPedido.almoxarifadoProduto.almoxarifado
  //             .descricao,
  //         RESPONSÁVEL:  c.departamento.descricao,
  //         TAREFA: c.tipoTarefaPedido.descricao,
  //         DATA: formatarData(c.dhCriacao),
  //       });
  //     });
  //   }

  //   return result;
  // };

  // const createHeadersTarefa = (keys) => {
  //   const result = [];
  //   for (let i = 0; i < keys.length; i += 1) {
  //     result.push({
  //       id: keys[i],
  //       name: keys[i],
  //       prompt: keys[i],
  //       width:
  //         (keys[i] === "Nº" && 30) ||
  //         (keys[i] === "Nº PEDIDO" && 30) ||
  //         (keys[i] === "DESTINO" && 70) ||
  //         (keys[i] === "RESPONSÁVEL" && 70) ||
  //         (keys[i] === "SOLICITANTE" && 50) ||
  //         40,
  //       align: "center",
  //       padding: 0,
  //     });
  //   }
  //   return result;
  // };

  // const headersTarefa = createHeadersTarefa([
  //   "Nº",
  //   "Nº PEDIDO",
  //   "STATUS",
  //   "SOLICITANTE",
  //   "DESTINO",
  //   "RESPONSÁVEL",
  //   "TAREFA",
  //   "DATA",
  // ]);

  // doc.setFont("", "bold");
  // doc.text("HISTÓRICO DE TAREFAS DO PEDIDO.:", 10, 100, null, null, "left");
  // doc.setFont("", "normal");

  // doc.table(10, 102, generateDataTarefa(), headersTarefa, {
  //   fontSize: 10,
  //   autoSize: false,
  //   // cellStart:"               "
  // });

  doc.save(`Relatorio do dia ${obterDataFormatada(true)}`);
}
